module.exports = __webpack_public_path__ + "img/pdf_footer02.443efc73.jpg";